<template>
  <div>
    <h3 class="display-3 text-xs-center" v-text="settings && settings.banner_title"></h3>
    <h3
      class="display-1 text-xs-center"
      v-text="settings && settings.banner_sub_title"
    ></h3>
    <div v-if="['sadmin', 'admin', 'accountant'].includes(role)">
      <ListLoader v-if="isLoadingDashboardData"></ListLoader>

      <div v-else>
        <h3 class="headline mb-0 pl-2">Today</h3>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 class="pa-2">
            <v-card>
              <v-card-title primary-title>
                <div style="width: 100%">
                  <h3 class="subheading mb-0">New Project Open</h3>
                  <v-divider></v-divider>
                  <h3 class="display-3 text-xs-center grey--text text--darken-2">
                    {{ dashboard && dashboard.today_new_project }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 class="pa-2">
            <v-card>
              <v-card-title primary-title>
                <div style="width: 100%">
                  <h3 class="subheading mb-0">Total received (Tk.)</h3>
                  <v-divider></v-divider>
                  <h3 class="display-3 text-xs-center grey--text text--darken-2">
                    {{ dashboard && dashboard.today_project_received }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 class="pa-2">
            <v-card>
              <v-card-title primary-title>
                <div style="width: 100%">
                  <h3 class="subheading mb-0">Total Expense (Tk.)</h3>
                  <v-divider></v-divider>
                  <h3 class="display-3 text-xs-center grey--text text--darken-2">
                    {{ todayToalExpense }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
        <br />
        <h3 class="headline mb-0 pl-2">This Month</h3>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 class="pa-2">
            <v-card>
              <v-card-title primary-title>
                <div style="width: 100%">
                  <h3 class="subheading mb-0">New Project Open</h3>
                  <v-divider></v-divider>
                  <h3 class="display-3 text-xs-center grey--text text--darken-2">
                    {{ dashboard && dashboard.month_new_project }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 class="pa-2">
            <v-card>
              <v-card-title primary-title>
                <div style="width: 100%">
                  <h3 class="subheading mb-0">Total received (Tk.)</h3>
                  <v-divider></v-divider>
                  <h3 class="display-3 text-xs-center grey--text text--darken-2">
                    {{ dashboard && dashboard.month_project_received }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md4 class="pa-2">
            <v-card>
              <v-card-title primary-title>
                <div style="width: 100%">
                  <h3 class="subheading mb-0">Total Expense (Tk.)</h3>
                  <v-divider></v-divider>
                  <h3 class="display-3 text-xs-center grey--text text--darken-2">
                    {{ monthToalExpense }}
                  </h3>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
// import ProcessOrderModal from "./ProcessOrder";
// import PricingTable from "./PricingTable";
// import HelloWorld from "./components/HelloWorld";
import VueScrollTo from "vue-scrollto";
import { ContentLoader, ListLoader } from "vue-content-loader";

export default {
  name: "App",
  components: {
    ContentLoader,
    ListLoader,
  },
  data() {
    return {
      isLoadingDashboardData: false,
      dashboard: {},
    };
  },
  computed: {
    // ...mapState({
    //   checkoutStatus: (state) => state.cart.checkoutStatus,
    //   cartItems: (state) => state.cart.items,
    //   serviceCategories: (state) => state.products.all,
    //   isHomePageScrollToOrder: (state) => state.common.isHomePageScrollToOrder,
    // }),
    // ...mapGetters("cart", {
    //   cartProducts: "cartProducts",
    //   // total: "cartTotalPrice"
    // }),
    todayToalExpense() {
      const { today_project_expense = 0, today_expense = 0 } = this.dashboard;
      return today_project_expense + today_expense;
    },
    monthToalExpense() {
      const { month_project_expense = 0, month_expense = 0 } = this.dashboard;
      return month_project_expense + month_expense;
    },
  },
  methods: {
    // ...mapActions("cart", ["addProductToCart", "removeProductFromCart"]),
    // ...mapActions("products", ["getAllProducts"]),
    async loadDashboardData() {
      this.isLoadingDashboardData = true;
      const res = await this.get("/dashboard");
      this.dashboard = res.data;
      this.isLoadingDashboardData = false;
    },
  },
  created() {
    // this.$store.dispatch("products/getAllProducts");
  },
  watch: {},
  mounted: function () {
    this.loadDashboardData();
  },
};
</script>

<style scoped>
/* .company-menu-container .menu-a {
  color: white;
  text-decoration: none;
}
.service-table {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 0;
  margin: 0;
}
.service-table th {
  border: thin solid #969696;
  margin: 0;
  background-color: #bfbfbf;
  padding: 5px;
  font-size: 20px;
}
.service-table td {
  border: thin solid black;
  padding: 10px;
  font-size: 19px;
}
.category-row {
} */
</style>
